import NumericTextboxWithLabel from './NumericTextboxWithLabel'
export default NumericTextboxWithLabel
